import { Component, inject } from '@angular/core';
import { CardRequiredService } from '../../core/card-required.service';
import { AddCardStep } from '../add-card-step/add-card-step';

/**
 * Global card_required 402 modal — see CardRequiredService for the flow.
 * Mounted once in app.html so it can pop up over whatever screen (order
 * detail, EPO/warranty wizard, task detail, project edit...) triggered a
 * card_required 402 on a live-project write.
 */
@Component({
  selector: 'app-card-required-modal',
  standalone: true,
  imports: [AddCardStep],
  template: `
    @if (svc.visible()) {
      <div class="card-required-overlay" (click)="svc.cancel()">
        <div class="card-required-modal" (click)="$event.stopPropagation()" role="dialog" aria-labelledby="card-required-modal-title">
          <h3 id="card-required-modal-title">Add a payment method</h3>
          <p class="card-required-copy">
            @if (svc.trialEndsAt()) {
              You won't be charged anything during your trial (ends {{ formatDate(svc.trialEndsAt()!) }}).
            }
            A card is required to keep working on this project — nothing else you do without one is affected.
          </p>
          <app-add-card-step
            mountId="stripe-card-element-required"
            [showCancel]="true"
            (cardAdded)="svc.cardAdded()"
            (cancel)="svc.cancel()" />
        </div>
      </div>
    }
  `,
  styles: [`
    .card-required-overlay {
      position: fixed; inset: 0; background: rgba(0, 0, 0, 0.5);
      display: flex; align-items: center; justify-content: center; z-index: 1000;
    }
    .card-required-modal {
      background: var(--rp-surface); border-radius: 14px; padding: 24px;
      width: min(420px, 92vw); box-shadow: 0 12px 40px rgba(0, 0, 0, 0.25);
    }
    .card-required-modal h3 { margin: 0 0 8px; }
    .card-required-copy { color: var(--rp-text-muted); font-size: 13px; margin: 0 0 16px; }
  `],
})
export class CardRequiredModal {
  protected svc = inject(CardRequiredService);

  formatDate(raw: string): string {
    return new Date(raw).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
  }
}
